//These are important for any string value!
//Determines if we should evaluate math expressions or not
export enum CHAR_TYPES {
  STRING = '_',
  NUMBER = '$',
  MATH = '&',
  BOOLEAN = '*',
}

